'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const TONES = {
    neutral: 'text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700',
    primary: 'text-primary-600 hover:text-primary-700 hover:bg-primary-50 dark:text-primary-400 dark:hover:bg-primary-900/30',
    danger: 'text-red-600 hover:text-red-700 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/30',
    success: 'text-green-600 hover:text-green-700 hover:bg-green-50 dark:text-green-400 dark:hover:bg-green-900/30',
    warning: 'text-amber-600 hover:text-amber-700 hover:bg-amber-50 dark:text-amber-400 dark:hover:bg-amber-900/30',
};
const SIZES = { xs: 'h-6 w-6', sm: 'h-7 w-7', md: 'h-8 w-8' };
/**
 * Icon-only button for row actions (view / edit / delete), a popup's ✕, remove-chip, etc.
 * For table toolbars (Columns, Filters) use ToolbarIconButton.
 *   <IconButton label="Delete" tone="danger" onClick={…}><Trash2 className="w-4 h-4" /></IconButton>
 */
export const IconButton = React.forwardRef(({ children, label, tone = 'neutral', size = 'xs', className, type = 'button', title, ...props }, ref) => (_jsx("button", { ref: ref, type: type, title: title ?? label, "aria-label": label, className: cn('inline-flex items-center justify-center shrink-0 rounded-md transition-colors', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500', 'disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent', SIZES[size], TONES[tone], className), ...props, children: children })));
IconButton.displayName = 'IconButton';
